import { ListItem, Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  HelpDialogList,
  SectionStack,
} from "./HelpDialogLayout";

export interface NightMealDialogProps extends HelpDialogLayoutProps {}
export default function NightMealDialog(props: NightMealDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "就寝前の夕食・夜食は眠気を感じるタイミングを後退させることが知られており、また、寝ている間に消化活動を行わなければいけないことから、睡眠の質を低下させてしまいます。さらに、翌朝までの食事をしていない時間が短くなるため、空腹を感じづらく朝食の欠食につながり、睡眠・覚醒リズムの乱れを引き起こす可能性があります。",
              ]}
            />
          </ContentStack>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">おすすめの対策</Typography>
          <ContentStack>
            <HelpDialogList>
              <ListItem>
                <BodyTypographies
                  contents={[
                    "就寝2時間以内の食事は、できるだけ避けるようにしましょう。",
                  ]}
                />
              </ListItem>
              <ListItem>
                <BodyTypographies
                  contents={[
                    "仕事などで夕食を遅い時間に食べなければならない場合は、夕食を2回に分けるのもおすすめです。具体的には夕方早い時間にご飯・パンなどの炭水化物を中心とする主食を食べ、帰宅時には栄養バランスをとるため、副菜を食べるようにすると、遅い食事の弊害を最小化することができます。",
                  ]}
                />
              </ListItem>
              <ListItem>
                <BodyTypographies
                  contents={[
                    "ただし、過度な空腹のままだと寝付きが悪くなることがあります。そのため、どうしても就寝前にお腹がすいてしまう場合は、栄養がありながらも低カロリーなものを少量だけ食べるのも一つの方法です。例えば、ナッツ（アーモンド、くるみなど）、ヨーグルトや牛乳、バナナ、オートミール、豆腐、温かい野菜スープなど消化の良いものを選びましょう。ただし、ストレスによる食欲ではないか、日中の食事が足りていたかを確認し、食べ過ぎには注意しましょう。",
                  ]}
                />
              </ListItem>
            </HelpDialogList>
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
